import { Tabs, colors } from '@sweep-io/sweep-design';
import {
  ConfigurationCanvasLeftPanel,
  ConfigurationCanvasPanelHeader,
  ConfigurationCanvasPanelContent,
} from '../../configuration-canvas-panel';
import { PanelCampaignsTab } from './campaign-dialog/new/PanelCampaignsTab';
import { useLoadHubspotFieldsAndWorkflows } from './campaign-dialog/new/HubspotCanvasPanel';
import { useState } from 'react';
import { Stack } from '@mui/material';
import { AttributionModelsPanel } from './marketing-attribution/AttributionModelsPanel';
import { HubspotOrgBlockedViews } from './unhappy-hubspot-pages/HubspotOrgBlockedViews';
import { CenteredCircularProgress } from '../../../common/CenteredCircularProgress';
import { useExpandedMode } from '../../configuration-canvas/panels-reserve-space/useExpandedMode';
import { PAGE_SIDE_PADDING } from '../../../../constants';
import { HubspotFiltersProvider } from './HubspotFiltersContext';

enum MarketingAttributionTabs {
  CAMPAIGN_ENROLLMENTS = 'CAMPAIGN_ENROLLMENTS',
  MODELS = 'MODELS',
}

export const MarketingAttributionPanel = () => {
  const { isExpandedMode } = useExpandedMode();
  const [activeTab, setActiveTab] = useState<MarketingAttributionTabs>(
    MarketingAttributionTabs.MODELS,
  );
  const { connectedHubspotOrg, crmOrgId } = useLoadHubspotFieldsAndWorkflows();

  return (
    <HubspotFiltersProvider>
      <ConfigurationCanvasLeftPanel
        withExpandedModeButton
        sx={{
          '.configuration-canvas-panel-content': {
            overflow: 'hidden',
          },
        }}
      >
        <ConfigurationCanvasPanelHeader withExpandedModeButton>
          Marketing Management
        </ConfigurationCanvasPanelHeader>
        <ConfigurationCanvasPanelContent sx={{ padding: 0 }}>
          <Stack
            sx={{
              padding: isExpandedMode
                ? `0 ${PAGE_SIDE_PADDING}px 0 ${PAGE_SIDE_PADDING}px`
                : `0 10px 0 16px`,
              '.MuiTabs-flexContainer': {
                gap: 2,
              },
              '.MuiTabs-root': {
                borderBottom: `1px solid ${colors.grey[200]}`,
              },
            }}
            data-testid="marketing-management-page"
          >
            <Tabs
              value={activeTab}
              tabs={[
                {
                  label: 'Attribution Models',
                  value: MarketingAttributionTabs.MODELS,
                },
                {
                  label: 'Campaign Enrollment',
                  value: MarketingAttributionTabs.CAMPAIGN_ENROLLMENTS,
                },
              ]}
              onChange={(event, tab) => {
                setActiveTab(tab as MarketingAttributionTabs);
              }}
            />
          </Stack>

          <Stack
            sx={{
              height: '100%',
              pt: isExpandedMode ? 3 : 2,
              overflow: 'hidden',
            }}
          >
            {activeTab === MarketingAttributionTabs.CAMPAIGN_ENROLLMENTS ? (
              <HubspotOrgBlockedViews smallScreenVersion={!isExpandedMode}>
                {!connectedHubspotOrg?.id || !crmOrgId ? (
                  <CenteredCircularProgress />
                ) : (
                  <PanelCampaignsTab crmOrgId={crmOrgId} hsOrgId={connectedHubspotOrg?.id} />
                )}
              </HubspotOrgBlockedViews>
            ) : null}

            {activeTab === MarketingAttributionTabs.MODELS && <AttributionModelsPanel />}
          </Stack>
        </ConfigurationCanvasPanelContent>
      </ConfigurationCanvasLeftPanel>
    </HubspotFiltersProvider>
  );
};
